module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaBAMAAABbZFH9AAAAAXNSR0IB2cksfwAAAC1QTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwaAoPgAAAA90Uk5TAGDvMCD/v58QoODy9cDwjy2hjQAAAJRJREFUeJxNz7ENAjEQRNGxLrmQxA2ALkcXEBGQUABIExw0QkgJtEEBVEADNEEf2N6dNY68fpL9jbTeoq8jN9rubmU6Ow7TgkThzAuQHYeJJwTO5ApCI6GTocgwqOL1JWrYqWInYE++YygXRm17K2pbRg6sb8VXLENoGY4qNFRhwQ/wVUbmo05emJ73cvRXCIyHvv8BzU4pUqQXXNoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/schedule-compose-close@2x.png
// module id = 898
// module chunks = 0